import React from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  emoji: '😴',
  text: 'Duermes las horas suficientes, pero despiertas agotado.'
}, {
  emoji: '⚖️',
  text: 'La grasa abdominal no disminuye aunque cuides tu alimentación.'
}, {
  emoji: '🧠',
  text: 'Tu mente no deja de pensar, incluso cuando intentas descansar.'
}, {
  emoji: '☕',
  text: 'Necesitas café para poder empezar el día.'
}, {
  emoji: '😤',
  text: 'Pierdes la paciencia por cosas pequeñas.'
}, {
  emoji: '🔁',
  text: 'Sientes que tu cuerpo trabaja en tu contra.'
}];
export const ProblemSection: React.FC = () => {
  return <section className="py-20 lg:py-28 bg-brand-lightmint" data-id="element-108">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-109">
        <motion.div className="text-center max-w-3xl mx-auto mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-110">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal" data-id="element-111">
            Si respondes "Sí" a 2 o más de estas señales, es muy probable que tu
            cortisol esté afectando tu bienestar.
          </h2>
          <p className="text-lg text-gray-600 mt-5" data-id="element-112">
            No es un diagnóstico médico, pero sí una señal de que tu cuerpo
            podría estar pidiendo ayuda.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-113">
          {painPoints.map((point, index) => <motion.div key={index} className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col items-center text-center gap-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-114">
              <span className="text-4xl" data-id="element-115">{point.emoji}</span>
              <p className="font-bold text-brand-charcoal text-lg leading-snug" data-id="element-116">
                {point.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div className="text-center" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} data-id="element-117">
          <p className="text-xl md:text-2xl font-bold text-brand-emerald max-w-3xl mx-auto leading-snug" data-id="element-118">
            Si te identificaste con varias de estas señales, no las ignores. La
            buena noticia es que puedes empezar a revertirlas con hábitos
            respaldados por evidencia.
          </p>
          <a href="#pricing" className="inline-block mt-8 px-8 py-4 text-lg font-bold text-white bg-brand-emerald hover:bg-brand-emeraldHover rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 text-center" data-id="element-119">
            QUIERO EMPEZAR MI CAMBIO HOY
          </a>
        </motion.div>
      </div>
    </section>;
};